import Centered from "../Centered";
import { WithSpace } from "../space/WithSpace";
import Spinner from "./Spinner";

export default function LoadingScreen() {
    return (
        <WithSpace all={8}>
            <Centered>
                <Spinner size="big" />
            </Centered>
        </WithSpace>
    );
}
